type BrandLogoProps = {
  variant?: "horizontal" | "login" | "splash";
};

export function BrandLogo({ variant = "horizontal" }: BrandLogoProps) {
  const login = variant !== "horizontal";
  return (
    <div className={`vicnet-brand vicnet-brand-${variant}`} aria-label="Vicnet Commercial AI Team">
      <img
        src={login ? "/brand/vicnet-commercial-ai-login.png" : "/brand/vicnet-commercial-ai-horizontal.png"}
        alt="Vicnet Commercial AI Team"
        width={login ? 900 : 1200}
        height={login ? 900 : 400}
        draggable={false}
      />
    </div>
  );
}
